<template>
    <div class="modal-card" style="width: auto; min-width: 680px">
        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ activeCompany?.Name || zoominfo?.name || 'New Company' }}
            </p>
        </header>
        <section class="modal-card-body">
            <loading v-if="loading"></loading>
            <o-tabs v-model="activeTab" rootClass="hide-tabs" class="hide-tabs" v-else>
                <o-tab-item :value="0" label="Mcl Company">
                    <div class="columns" v-if="zoominfo && company.ID && saveAs == 'mcl'">
                        <div class="column is-12">
                            <info-line label="Invenias record">
                                <div v-if="activeCompany.InveniasID" class="level">
                                    <div class="level-left"><a :href="$filters.InveniasUrl(activeCompany.InveniasID)" target="_blank">View <o-icon icon="external-link" /></a></div>
                                    <div class="level-right ml-4">
                                        <o-button variant="danger" size="small" icon-left="unlink" class="is-pulled-right" :disabled="unlinking_invenias" :loading="unlinking_invenias" outlined @click="UnlinkInvenias">Unlink</o-button>
                                    </div>
                                </div>
                                <div v-else><o-button v-if="$store.getters.hasAccess('DedupeAccess')" variant="default" size="small" icon-left="link" @click="LinkInvenias">Link to Invenias</o-button></div>
                            </info-line>

                            <info-line label="ZoomInfo record">
                                <div v-if="activeCompany.ZoomInfoId" class="level">
                                    <div class="level-left"><a :href="activeCompany?.ZoomInfo?.ZoomInfoUrl" target="_blank">View <o-icon icon="external-link" /></a></div>
                                    <div class="level-right ml-4"><o-button variant="danger" size="small" icon-left="unlink" class="is-pulled-right" :disabled="unlinking_zoominfo" :loading="unlinking_zoominfo" outlined @click="UnlinkZoomInfo">Unlink</o-button>
                                    </div>
                                </div>
                                <!--<div v-else class="level">
                                    <o-button variant="default" size="small" icon-left="sparkles" @click="LinkZoomInfo">Enrich with ZoomInfo</o-button>
                                </div>-->
                            </info-line>


                        </div>
                    </div>
                    <div v-else-if="zoominfo">
                        <div class="notification is-warning is-light">
                            Save this company before linking to Invenias
                        </div>
                    </div>
                    <div class="columns" v-if="zoominfo">
                        <div class="column is-6">
                            <info-line label="Name" :value="zoominfo.ZI_C_COMPANY_NAME"></info-line>
                            <info-line label="City" :value="zoominfo.ZI_C_COMPANY_CITY"></info-line>
                            <info-line label="Country" :value="zoominfo.ZI_C_COMPANY_COUNTRY"></info-line>
                            <info-line label="Web Address" :value="FixLink(zoominfo.ZI_C_COMPANY_URL)"></info-line>
                            <info-line label="Global Revenue" :value="zoominfo.ZI_C_COMPANY_REVENUE_RANGE"></info-line>
                            <br />
                            <info-line label="Parent" :value="zoominfo.ZI_C_IMMEDIATE_PARENT_NAME || 'None'"></info-line>
                        </div>
                    </div>
                </o-tab-item>
            </o-tabs>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
            <o-button variant="light" @click="Close">Close</o-button>
            <!--<o-button variant="default" @click="activeTab++" v-if="activeTab < 1">Next</o-button>-->
            <o-button variant="primary" icon-left="save" :disabled="!isValid || saving || loading || unlinking_zoominfo || unlinking_invenias" :loading="saving" @click="DoSave" v-if="zoominfo">Save Company</o-button>
        </footer>
    </div>
</template>
<script>
    import { ref, inject, computed, watch, onMounted, getCurrentInstance } from "vue";
    import infoLine from "@/components/webComponents/infoLine.vue";
    import enrichmentSearchModal from "@/components/modals/zoom-info/enrichment-search.vue";
    import linkCompanyModal from "@/components/modals/invenias/link-company.vue";

    export default {
        components: {
            infoLine
        },
        props: {
            company: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            saveAs: {
                type: String,
                default: "mcl" // options: 'mcl', 'invenias'
            }
        },
        emits: ["close", "saved"],
        setup(props, context) {
            const http = inject("$http");
            const oruga = inject("$oruga");
            const success = inject("$success");
            const error = inject("$error");

            const loading = ref(true);
            const saving = ref(false);
            const unlinking_invenias = ref(false);
            const unlinking_zoominfo = ref(false);
            const activeTab = ref(0);
            const zoominfo = ref(props.company.ZoomInfo);
            const companyRef = ref(props.company || {});
            const activeCompany = ref(JSON.parse(JSON.stringify(props.company || {})));

            const isValid = computed(() => {
                return true; //TODO: Ensure all required non-zoominfo fields are all filled in.
            })


            const GetEnrichment = async (itemId) => {
                loading.value = true;

                try {
                    const resp = await http.get("/api/v2/company/zoominfo/" + itemId + "/enrich");
                    zoominfo.value = resp.data;
                    activeCompany.value.ZoomInfo = zoominfo.value;
                    companyRef.value.ZoomInfo = zoominfo.value;
                }
                catch (err) {
                    console.error(err);
                }

                loading.value = false;
            }

            const FixLink = (url) => {
                if (url) {
                    if (url.startsWith("http://") || url.startsWith("https://")) return url;
                    else {
                        url = "https://" + url;
                        return url;
                    }
                }
                else return "#";
            }


            const UnlinkInvenias = async () => {
                if (confirm("You're about to unlink this company from Invenias. Are you sure?")) {
                    const mclId = activeCompany.value.ID;
                    unlinking_invenias.value = true;
                    const response = await http.get(`/api/v2/company/${mclId}/invenias/unlink`);
                    if (response.data.success) {
                        activeCompany.value.InveniasID = null;
                        success("Unlinked from Invenias");
                    }
                    else {
                        error(response.data.errors[0]);
                    }
                    unlinking_invenias.value = false;
                }
            }
            const UnlinkZoomInfo = async () => {
                if (confirm("You're about to unlink this company from ZoomInfo. Are you sure?")) {
                    const mclId = activeCompany.value.ID;
                    unlinking_zoominfo.value = true;
                    const response = await http.get(`/api/v2/company/${mclId}/zoominfo/unlink`);
                    if (response.data.success) {
                        companyRef.value.ZoomInfoId = null;
                        companyRef.value.ZoomInfo = null;
                        activeCompany.value.ZoomInfoId = null;
                        success("Unlinked from ZoomInfo");
                        zoominfo.value = null;
                        LinkZoomInfo(); //Company needs to have a link to ZoomInfo before it can be saved.
                    }
                    else {
                        error(response.data.errors[0]);
                    }
                    unlinking_zoominfo.value = false;
                }
            }

            const Close = () => {
                context.emit("close");
            };

            const LinkInvenias = () => {
                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: linkCompanyModal,
                    trapFocus: true,
                    props: {
                        company: activeCompany.value
                    },
                    events: {
                        close: (result) => {
                            if (result && result.linked) {
                                activeCompany.value.InveniasID = result.inveniasId
                            }
                        }
                    }
                });
            };

            const LinkInveniasOLD = async () => {

                let hasError = false;

                const companyId = activeCompany.value.ID;
                const inveniasId = activeCompany.value.InveniasID;
                const zoominfoId = zoominfo.value.ZI_C_COMPANY_ID;

                if (!hasError && companyId) {
                    try {
                        await http.get(`${companyId}/invenias/${inveniasId}/link`);
                        activeCompany.value.InveniasID = inveniasId;
                    }
                    catch (err) {
                        hasError = true;
                        console.error(err);
                        error("Failed to link to Invenias");
                    }
                }

                if (!hasError && inveniasId && zoominfoId) {
                    try {
                        await http.get(`invenias/${inveniasId}/zoominfo/${zoominfoId}/link`);
                        activeCompany.value.InveniasID = inveniasId;
                        activeCompany.value.ZoomInfoId = zoominfoId;
                    }
                    catch (err) {
                        hasError = true;
                        console.error(err);
                        error("Failed to link to Invenias");
                    }
                }

            }

            const LinkZoomInfo = () => {
                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: enrichmentSearchModal,
                    trapFocus: true,
                    props: {
                        company: activeCompany.value,
                        autofill: true
                    },
                    events: {
                        close: (result) => {
                            if (result && result.linked) {
                                companyRef.value.ZoomInfoId = result.zoominfoId;
                                activeCompany.value.ZoomInfoId = result.zoominfoId;
                                GetEnrichment(result.zoominfoId);
                            }
                            else {
                                Close();
                            }
                        }
                    }
                });
            };

            const LinkToZoomInfoEnrichment = async () => {
                if (activeCompany.value.ID) {
                    return await http.get("/api/v2/company/" + activeCompany.value.ID + "/zoominfo/" + zoominfo.value.ZI_C_COMPANY_ID + "/link");
                }
            }

            const ConvertToCompany = () => {
                //This can be shell'd in favor of ZoomInfo data.
                activeCompany.value.Name = activeCompany.value?.Name || zoominfo.value.ZI_C_COMPANY_NAME;
                activeCompany.value.ZoomInfoId = zoominfo.value.ZI_C_COMPANY_ID;
                if (!activeCompany.value.InveniasID && zoominfo.value.InveniasId) {
                    activeCompany.value.InveniasID = zoominfo.value.InveniasId; //Links up Invenias if able to.
                }
            }

            const SaveCompany = async (comp) => {
                let qs = "";
                if (!activeCompany.value.ID) {
                    qs = "?recache=true";
                }

                let response = undefined;
                saving.value = true;
                try {
                    response = await http.post("/api/v2/company" + qs, comp || activeCompany.value);
                    success("Company saved");
                } catch (err) {
                    console.error(err);
                }

                return response;
            };

            const Save = async () => {
                saving.value = true;
                ConvertToCompany();

                const response = await SaveCompany(activeCompany.value);
                const company = response.data;
                company.ZoomInfo = activeCompany.value.ZoomInfo;
                company.Invenias = activeCompany.value.Invenias;
                activeCompany.value = company;
                await LinkToZoomInfoEnrichment();
                saving.value = false;

                context.emit("saved", { company: activeCompany.value, close: Close });
            };

            const SaveInvenias = async () => {
                saving.value = true;

                try {
                    const response = await http.post(`/api/v2/company/zoominfo/${zoominfo.value.ZI_C_COMPANY_ID}/invenias/newCompany`);
                    //const company = response.data;
                    //company.ZoomInfo = activeCompany.value.ZoomInfo;
                    //company.Invenias = activeCompany.value.Invenias;
                    success("Company saved to Invenias");
                    context.emit("saved", { company: response.data, close: Close });
                }
                catch (err) {
                    console.error(err);
                }

                saving.value = false;
            }

            const DoSave = async () => {
                if (props.saveAs == "mcl") {
                    await Save();
                }
                else {
                    await SaveInvenias();
                }
            }


            onMounted(() => {
                if (!props.company.ZoomInfo) {
                    oruga.modal.open({
                        parent: getCurrentInstance(),
                        component: enrichmentSearchModal,
                        width: 960,
                        trapFocus: true,
                        cancelable: false,
                        props: {
                            type: "mcl",
                            company: props.company,
                            review: false,
                            autofill: true
                        },
                        events: {
                            close: (result) => {
                                if (!result) context.emit("close");
                            },
                            select: (result) => {
                                zoominfo.value = result.item;
                                if (zoominfo.value) {
                                    activeCompany.value.ZoomInfoId = zoominfo.value.id;
                                    GetEnrichment(zoominfo.value.id);
                                    result.close('noop');
                                }
                            }
                        }
                    });
                }
                else {
                    loading.value = false;
                }
            })

            return {
                loading,
                saving,
                unlinking_invenias,
                unlinking_zoominfo,
                activeTab,
                activeCompany,
                zoominfo,
                isValid,
                FixLink,
                UnlinkInvenias,
                UnlinkZoomInfo,
                Close,
                LinkInvenias,
                LinkZoomInfo,
                Save,
                DoSave
            }
        }
    }
</script>
<style lang="scss">
    .hide-tabs {
        & nav.tabs {
            display: none;
        }
    }
</style>
